import { field, text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";

export default class Supplier extends BaseModel {
  static table = "suppliers";
  @text("name") name: string;
  @text("supp_code") suppCode: string;
  @field("active") active: boolean;
}
